export default "__VITE_ASSET__BQJ719DJ__"